// import React from 'react'
import { useParams } from "react-router-dom";
import side_img from "../../../../assets/case-study.png";
// import ButtonComponent from "../../../Components/Buttons/ButtonComponent";
import '../CaseStudyHome.css'

const CaseStudyHomeContent = {
  phenom: {
    content1: "How",
    content2: "Hirestar.io Helped",
    content3: "Phenom Accelerate Background Verification",
    content4: "and Slash HR Workload by 80%"
  },
  goken:{
    content1: "How",
    content2: "Hirestar.io Helped",
    content3: "Goken America Accelerate Background Verification",
    content4: "and Slash HR Workload by 80%"
  },
  ikf:{
    content1: "How",
    content2: "Hirestar.io Helped",
    content3: "IKF Finance Accelerate Background Verification",
    content4: "and Slash HR Workload by 80%"
  },
  monitra:{
    content1: "How",
    content2: "Hirestar.io Helped",
    content3: "Monitra Healthcare Accelerate Background Verification",
    content4: "and Slash HR Workload by 80%"
  },
  incuspaze:{
    content1: "How",
    content2: "Hirestar.io Helped",
    content3: "Incuspaze Accelerate Background Verification",
    content4: "and Slash HR Workload by 80%"
  },
}

export default function PhenomCaseStudyHome() {
  const { companyName } = useParams(); // For Getting the Route Name
  const { content1, content2, content3, content4 } = CaseStudyHomeContent[companyName]; // Render the content accourding to the param or company name
  return (
    <section className=" overflow-hidden case_background  mx-4">
      {/* Desktop and Tablet View */}
      <div className="flex w-full h-full flex-col lg:flex-row">
        {/* Text Box */}
        <div className="h-full rounded-lg  flex items-center justify-center text-center p-6 lg:mt-0 mt-16">
          <h3 className="text-[43.26px] font-semibold leading-relaxed text-left text-white">
             {content1}<br /> {content2} <br />
            {content3} <br />
            {content4}
          </h3>
        </div>

        {/* Image Box */}
        <div className="h-full rounded-lg flex items-center justify-center">
          <img src={side_img} alt="company logo" className="max-w-full max-h-full object-contain" />
        </div>
      </div>

    </section>
  )
}
